import {
  ButtonGroup,
  Button,
  Modal,
  Spinner,
  useSnackbar
} from "@walmart-web/livingdesign-components";
import React, { useState } from "react";
import { getService } from "../../../axios/axios";
import { EXTERNAL_USER_SERVICE } from "../../../constants/baseURLs";
import { CANCEL } from "../../../constants/actionButtons";
import { getErrorMessage } from "../../../helpers/utils";

const InactivateActions = (props) => {
  const { onInactivate, onCancel, loading } = props;

  return (
    <ButtonGroup>
      <Button
        id="cancel-btn"
        data-testid="cancel-btn"
        size="medium"
        onClick={onCancel}
        disabled={loading}
      >
        {CANCEL}
      </Button>
      <Button
        variant="destructive"
        size="medium"
        data-testid="inactivate-btn"
        id="inactivate-btn"
        onClick={onInactivate}
        disabled={loading}
      >
        {loading ? (
          <Spinner color="white" size="small" />
        ) : (
          "Inactivate"
        )}
      </Button>
    </ButtonGroup>
  );
};

const InactivateRateModal = (props) => {
  const {
    open,
    setOpen,
    rateId,
    rateType, // 'practice-area' or 'matter-specific'
    onSuccess,
    warningMessage 
  } = props;

  const [loading, setLoading] = useState(false);
  const { addSnack } = useSnackbar();

  const handleInactivate = async () => {
    setLoading(true);
    try {
      const endpoint = rateType === "practice-area" 
        ? `/practice-area-specific-rates/v1/${rateId}/inactivate`
        : `/matter-specific-rates/v1/${rateId}/inactivate`;

      await getService(EXTERNAL_USER_SERVICE, endpoint);
      
      addSnack({ 
        message: `${rateType === "practice-area" ? "Practice area" : "Matter specific"} rate has been successfully inactivated.`,
        variant: "success"
      });
      
      setOpen(false);
      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      addSnack({ 
        message: getErrorMessage(error),
        variant: "error"
      });
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal
      data-testid="inactivate-rate-modal"
      actions={
        <InactivateActions
          onInactivate={handleInactivate}
          onCancel={handleClose}
          loading={loading}
        />
      }
      isOpen={open}
      onClose={handleClose}
      size="medium"
      title="Inactivate Rate"
    >
      <div style={{ whiteSpace: 'pre-line' }}>
        {warningMessage}
      </div>
    </Modal>
  );
};

export default InactivateRateModal;
